export const environment = {
  production: true,
  isUnimedBH: false,
  relativeURL: false,
  loginAzure: false,
  exibirLogin: true,
  pathImagens: 'ALERTA-ES',
  googleapi: 'AIzaSyDBQzwf4e4DTAgMIj__qDhEEBHEvcKMe8s',
  principalAPI: 'https://sistemahom.alerta.es.gov.br/principal',
  portalAPI: 'https://sistemahom.alerta.es.gov.br/portal',
  atendimento: 'https://sistemahom.alerta.es.gov.br/atendimento',
  portal: 'https://sistemahom.alerta.es.gov.br/portal',
  principal: 'https://sistemahom.alerta.es.gov.br/principal',
  supervisao: 'https://sistemahom.alerta.es.gov.br/supervisao',
  consultaunificada: 'https://sistemahom.alerta.es.gov.br/consultaUnificada',
  medicoregulador: 'https://sistemahom.alerta.es.gov.br/medicoRegulador',
  radioOperador: 'https://sistemahom.alerta.es.gov.br/radio-operador',
  despacho: 'https://sistemahom.alerta.es.gov.br/despacho',
  vistoria: 'https://sistemahom.alerta.es.gov.br/vistoria',
  filemanager: 'https://sistemahom.alerta.es.gov.br/filemanager',
  websocketURL: 'wss://sistemahom.alerta.es.gov.br/mensageria/socket',
  auth: 'https://10.243.100.20:8080/auth',
  wsPort: 80,
  urlDadosCidadao: 'https://acessocidadao.es.gov.br/is/connect/userinfo',
  urlLoginAcessoCidadao : 'https://acessocidadao.es.gov.br/is/connect/authorize',
  emailDefaultLoginCidadao: 'thalyta.morares@csiway.com.br',
  senhaDefaultUsuarioCidadao: '123',
  usuarioDefautCidadao: 'I79650197010',
  clientIdAcessoCidadao: 'd830e5a8-827e-4118-879a-0f975e6f5e19',
  nonceAcessoCidadao: '88b939c1-0870-4ad5-93aa-1017fd4f9cbc',
  urlredirectCidadao:'https://sistemahom.alerta.es.gov.br/principal/acessocidadao/login/alerta'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts